import React, {createContext, useContext} from "react";
import { useMediaQuery } from 'react-responsive'
import { ThemeProvider } from 'styled-components';

const ScreenContext = createContext(null);

export const ScreenProvider = ({children}) => {
    const isLargeDesktop = useMediaQuery({ minWidth: 1201 })
    const isDesktop = useMediaQuery({ maxWidth: 1200 })
    const isMobile = useMediaQuery({ maxWidth: 600 })
    
    return <ThemeProvider theme={{isMobile,isDesktop,isLargeDesktop}}><ScreenContext.Provider value={{isDesktop, isMobile, isLargeDesktop}}>{children}</ScreenContext.Provider></ThemeProvider>
}

export const useGetScreen = () => {
    return useContext(ScreenContext)
}